const BASE_SCREEN_WIDTH = 1440

export default function pixelToViewport (px, viewport) {
  return (px / BASE_SCREEN_WIDTH) * viewport.width
}
